// Cart Drawer Functionality 

var openBtn = document.getElementById('open-cart-drawer');
var drawer = document.querySelector('.cart-drawer');
var closeBtn = document.querySelector('.cart-drawer__close');
var overlay = document.querySelector('.cart-drawer__overlay');

function openCartDrawer() {
  if (drawer) {
    drawer.classList.add('is-open');
    document.documentElement.classList.add('disable-overflow-y');
  }
}

function closeCartDrawer() {
  if (drawer) {
    drawer.classList.remove('is-open');
    document.documentElement.classList.remove('disable-overflow-y');
  }
}

async function updateCartDrawer() {
    try {
      const response = await fetch('/?section_id=cart-drawer');
      const html = await response.text();
      
      // Create a temporary div to parse the HTML
      const tempDiv = document.createElement('div');
      tempDiv.innerHTML = html;
      
      // Find the cart drawer content in the response
      const newCartDrawer = tempDiv.querySelector('.cart-drawer');
      if (newCartDrawer && drawer) {
        // Replace the content of the existing cart drawer
        drawer.innerHTML = newCartDrawer.innerHTML;
        
        // Re-attach event listeners after content refresh
        attachCartDrawerListeners();
      }
    } catch (error) {
      console.error('Error refreshing cart drawer:', error);
    }
}

function updateCartCount(count) {
  document.querySelectorAll('.cart-count').forEach(el => {
    el.textContent = count;
  });
}

async function updateLineItem(lineItemKey, quantity) {
  console.log('Updating line item:', lineItemKey, 'to quantity:', quantity);
  
  try {
    const response = await fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        updates: {
          [lineItemKey]: quantity
        }
      })
    });
    
    console.log('Cart update response:', response.status, response.ok);
    
    if (response.ok) {
      // Only update cart drawer, don't make additional API calls
      await updateCartDrawer();
      console.log('Cart updated successfully');
    } else {
      console.error('Cart update failed:', response.status);
      const errorText = await response.text();
      console.error('Error response:', errorText);
    }
  } catch (error) {
    console.error('Error updating cart:', error);
  }
}

function attachCartDrawerListeners() {
  // Close button
  const closeBtn = document.querySelector('.cart-drawer__close');
  if (closeBtn) {
    closeBtn.onclick = closeCartDrawer;
  }

  // Overlay
  const overlay = document.querySelector('.cart-drawer__overlay');
  if (overlay) {
    overlay.onclick = closeCartDrawer;
  }

  // Escape key
  document.onkeyup = function(e) {
    if (e.code === 'Escape') closeCartDrawer();
  };

  // Quantity minus/plus
  document.querySelectorAll('.cart-drawer .quantity-input').forEach(selector => {
    const minusBtn = selector.querySelector('.quantity-input__button--minus');
    const plusBtn = selector.querySelector('.quantity-input__button--plus');
    const input = selector.querySelector('input[type="number"], input[type="text"]');
    const lineItemKey = minusBtn?.dataset.lineitemKey || plusBtn?.dataset.lineitemKey || input?.dataset.itemKey;

    console.log('Setting up quantity controls:', {
      minusBtn: !!minusBtn,
      plusBtn: !!plusBtn,
      input: !!input,
      lineItemKey: lineItemKey
    });

    if (minusBtn) {
      minusBtn.onclick = async () => {
        console.log('Minus button clicked, lineItemKey:', lineItemKey);
        let qty = parseInt(input.value, 10);
        console.log('Current quantity:', qty);
        if (qty > 1) {
          await updateLineItem(lineItemKey, qty - 1);
        } else {
          await updateLineItem(lineItemKey, 0); // Remove item
        }
      };
    }
    if (plusBtn) {
      plusBtn.onclick = async () => {
        console.log('Plus button clicked, lineItemKey:', lineItemKey);
        let qty = parseInt(input.value, 10);
        console.log('Current quantity:', qty);
        await updateLineItem(lineItemKey, qty + 1);
      };
    }
  });

  // Checkout button
  const checkoutBtn = document.querySelector('.cart-drawer__checkout-btn');
  if (checkoutBtn) {
    checkoutBtn.onclick = function(e) {
      e.preventDefault();
      window.location.href = checkoutBtn.getAttribute('data-checkout-url') || '/checkout';
    };
  }
}

// Note: Form submission is handled by main-product.js to avoid duplicate handling

// Open cart drawer (header cart icon)
document.querySelectorAll('.header-cart, .js-cart-link, .cart-drawer-toggle').forEach(cartIcon => {
  cartIcon.onclick = function(e) {
    e.preventDefault();
    openCartDrawer();
  };
});

// Initial attach for listeners in the cart drawer
document.addEventListener('DOMContentLoaded', attachCartDrawerListeners);